// Lista completa delle professioni del Ticino
export const TICINO_PROFESSIONS = [
  'Addetto/a alla cucitura',
  'Addetto/a alla lavorazione del legno',
  'Addetto/a alla lavorazione di materie sintetiche',
  'Addetto/a alla logistica',
  'Addetto/a alle attività agricole',
  'Addetto/a alle cure sociosanitarie',
  'Addetto/a d\'albergo',
  'Addetto/a d\'informatica',
  'Addetto/a di cucina',
  'Addetto/a di economia domestica',
  'Addetto/a di macelleria',
  'Addetto/a di ristorazione',
  'Addetto/a installatore di sistemi di refrigerazione',
  'Agente di polizia',
  'Agente tecnico di materie sintetiche',
  'Agricoltore/trice',
  'Aiuto meccanico/a',
  'Aiuto metalcostruttore/trice',
  'Aiuto muratore/trice',
  'Aiuto piastrellista',
  'Albergatore-ristoratore / Albergatrice-ristoratrice',
  'Architetto/a',
  'Armaiolo/a',
  'Artigiano/a del cuoio e dei tessili',
  'Artista (arti figurative)',
  'Artista teatrale',
  'Assistente alla stampa e all\'allestimento',
  'Assistente d\'ufficio',
  'Assistente del commercio al dettaglio',
  'Assistente dentale',
  'Assistente di cura',
  'Assistente di farmacia',
  'Assistente di manutenzione per automobili',
  'Assistente di profilassi',
  'Assistente di studio medico',
  'Assistente di studio veterinario',
  'Assistente verniciatore/trice',
  'Autista di veicoli pesanti',
  'Cabin crew member',
  'Cantiniere/a',
  'Carpentiere/a',
  'Carrozziere/a lattoniere/a',
  'Carrozziere/a verniciatore/trice',
  'Conservatore-restauratore / Conservatrice-restauratrice',
  'Consulente in sicurezza sociale',
  'Controllore/a del traffico aereo',
  'Costruttore/trice d\'impianti e apparecchi',
  'Costruttore/trice di binari',
  'Costruttore/trice nautico',
  'Creatore/trice d\'abbigliamento (abbigliamento da donna)',
  'Creatore/trice di tessuti',
  'Cucitore/trice d\'interni',
  'Cuoco/a',
  'Cuoco/a in dietetica',
  'Custode di cavalli',
  'Decoratore/trice 3D',
  'Decoratore/trice d\'interni',
  'Decoratore/trice tessile',
  'Designer design di prodotto (industrial design)',
  'Designer design visivo (computer animation)',
  'Designer design visivo (film)',
  'Designer design visivo (visual merchandising design)',
  'Designer design visivo (web design)',
  'Designer in architettura d\'interni',
  'Designer in comunicazione visiva',
  'Disegnatore/trice (architettura d\'interni)',
  'Disegnatore/trice (architettura)',
  'Disegnatore/trice (ingegneria civile)',
  'Disegnatore/trice (pianificazione del territorio)',
  'Disegnatore-metalcostruttore / Disegnatrice-metalcostruttrice',
  'Docente del secondario I',
  'Docente del secondario II',
  'Docente di musica e movimento',
  'Docente di scuola dell\'infanzia',
  'Docente di scuola elementare',
  'Economista aziendale',
  'Educatore/trice dell\'infanzia',
  'Elettricista per reti di distribuzione',
  'Elettronico/a',
  'Elettronico/a multimediale',
  'Ergoterapista',
  'Estetista',
  'Fabbro/a di veicoli',
  'Fabbro-maniscalco / Fabbra-maniscalca',
  'Falegname',
  'Filmaker cine-televisivo',
  'Fiorista',
  'Fisioterapista',
  'Forestale',
  'Formatore/trice',
  'Funzionario/a amministrativo/a degli Enti locali',
  'Geomatico/a',
  'Gessatore/trice',
  'Gestore/trice dell\'informazione e della documentazione',
  'Giardiniere/a',
  'Giardiniere/a (floricoltura)',
  'Giardiniere/a (paesaggismo)',
  'Giardiniere/a (piante perenni)',
  'Giardiniere/a (vivaismo)',
  'Grafico/a',
  'Guardia di confine',
  'Guardiano di animali',
  'Impiegato/a d\'albergo',
  'Impiegato/a del commercio al dettaglio',
  'Impiegato/a di commercio',
  'Impiegato/a di commercio (banche)',
  'Impiegato/a di economia domestica',
  'Impiegato/a di gastronomia standardizzata',
  'Impiegato/a di ristorazione',
  'Impiegato/a in logistica',
  'Infermiere/a',
  'Infermiere/a esperto/a in cure di anestesia',
  'Infermiere/a esperto/a in cure intense',
  'Infermiere/a esperto/a in cure urgenti',
  'Informatico/a',
  'Informatico/a di gestione',
  'Ingegnere/a civile',
  'Ingegnere/a dei media',
  'Ingegnere/a forestale',
  'Ingegnere/a gestionale',
  'Ingegnere/a in agronomia',
  'Ingegnere/a in agronomia (settori agricoli speciali)',
  'Ingegnere/a in chimica',
  'Ingegnere/a in elettronica',
  'Ingegnere/a in elettrotecnica',
  'Ingegnere/a in enologia',
  'Ingegnere/a in geomatica',
  'Ingegnere/a in informatica',
  'Ingegnere/a in meccanica',
  'Ingegnere/a in microtecnica',
  'Ingegnere/a in tecnica automobilistica',
  'Ingegnere/a in tecnica dei sistemi',
  'Ingegnere/a in tecnica energetica e ambientale',
  'Ingegnere/a in tecnologia del vivente',
  'Ingegnere/a in telecomunicazioni',
  'Installatore/trice di sistemi di refrigerazione',
  'Interactive media designer',
  'Laboratorista',
  'Levatrice',
  'Macellaio-salumiere / Macellaia-salumiera',
  'Manager del turismo',
  'Manutentore/trice nautico/a',
  'Marmista',
  'Massaggiatore/trice',
  'Massaggiatore/trice medicale',
  'Meccanico/a di apparecchi a motore',
  'Meccanico/a di biciclette',
  'Meccanico/a di macchine agricole',
  'Meccanico/a di macchine edili',
  'Meccanico/a di manutenzione per automobili',
  'Meccanico/a di motoleggere e biciclette',
  'Meccanico/a di motoveicoli',
  'Meccanico/a di produzione',
  'Meccatronico/a d\'automobili',
  'Metalcostruttore/trice',
  'Montatore/trice in automazione',
  'Muratore/trice',
  'Musicista',
  'Operatore/trice della pietra',
  'Operatore/trice di edifici e infrastrutture',
  'Operatore/trice in automazione',
  'Operatore/trice in orologeria',
  'Operatore/trice per la comunicazione per la clientela',
  'Operatore/trice per la promozione dell\'attività fisica e della salute',
  'Operatore/trice per la pulizia ordinaria e manutentiva',
  'Operatore/trice postpress',
  'Operatore/trice sociale (Educatore/trice sociale/Assistente sociale)',
  'Operatore/trice socioassistenziale (Assistenza agli handicappati)',
  'Operatore/trice socioassistenziale (Assistenza all\'infanzia)',
  'Operatore/trice sociosanitario/a',
  'Orologiaio/a (industriale)',
  'Orologiaio/a (riparazione)',
  'Orologiaio/a pratico/a',
  'Orticoltore/trice',
  'Panettiere-pasticciere-confettiere / Panettiera-pasticciera-confettiera',
  'Parrucchiere/a',
  'Pianificatore/trice elettricista',
  'Piastrellista',
  'Pilota d\'aerei',
  'Pilota militare',
  'Pittore/trice',
  'Pittore/trice di scenari',
  'Podologo/a',
  'Poligrafo/a',
  'Polimeccanico/a',
  'Posatore/trice di pavimenti',
  'Progettista meccanico/a',
  'Progettista nella tecnica della costruzione impianti sanitari',
  'Progettista nella tecnica della costruzione riscaldamento',
  'Progettista nella tecnica della costruzione ventilazione',
  'Public Manager',
  'Quadro dirigente degli Enti locali',
  'Scalpellino/a',
  'Scultore/trice su pietra',
  'Segretario/a d\'albergo hôtellerie Suisse',
  'Selvicoltore/trice',
  'Soccorritore/trice',
  'Sottufficiale di professione',
  'Specialista dei servizi della navigazione aerea',
  'Specialista della conduzione di un gruppo',
  'Specialista della formazione professionale',
  'Specialista doganale',
  'Specialista in attivazione',
  'Specialista in materia di assicurazione sociale',
  'Specialista in informazione e documentazione',
  'Specialista turistico/a',
  'Tecnico/a d\'aeromobili',
  'Tecnico/a di radiologia medica',
  'Tecnico/a di sala operatoria',
  'Tecnico/a dell\'abbigliamento in gestione del prodotto',
  'Tecnico/a della moda in progettazione e collezione',
  'Tecnico/a in costruzioni meccaniche',
  'Tecnico/a in direzione di lavori edili',
  'Tecnico/a in elettrotecnica',
  'Tecnico/a in tecnica degli edifici',
  'Tecnico/a in tecnica dei sistemi (chimico-farmaceutica)',
  'Tecnico/a in analisi biomediche',
  'Tecnologo/a del latte',
  'Tecnologo/a di chimica e chimica farmaceutica',
  'Tecnologo/a di imballaggio',
  'Tecnologo/a di stampa',
  'Tecnologo/a tessile (design)',
  'Ufficiale di professione',
  'Viticoltore/trice'
];

// Funzione per cercare professioni con filtro fuzzy
export const searchProfessions = (query: string, maxResults: number = 10): string[] => {
  if (!query.trim()) return [];
  
  const normalizedQuery = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  
  return TICINO_PROFESSIONS
    .filter(profession => {
      const normalizedProfession = profession.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      
      // Ricerca esatta
      if (normalizedProfession.includes(normalizedQuery)) return true;
      
      // Ricerca per parole separate
      const queryWords = normalizedQuery.split(/\s+/);
      return queryWords.every(word => 
        normalizedProfession.includes(word) || 
        word.length >= 3 && normalizedProfession.includes(word)
      );
    })
    .slice(0, maxResults);
};

// Funzione per ottenere suggerimenti basati su categoria
export const getProfessionSuggestions = (category?: string): string[] => {
  if (!category) return TICINO_PROFESSIONS.slice(0, 20); // Prime 20 professioni
  
  const categoryMap: Record<string, string[]> = {
    'tecnologia': ['Informatico/a', 'Informatico/a di gestione', 'Ingegnere/a in informatica', 'Designer design visivo (web design)'],
    'sanità': ['Infermiere/a', 'Assistente di cura', 'Fisioterapista', 'Ergoterapista', 'Podologo/a'],
    'edilizia': ['Muratore/trice', 'Falegname', 'Pittore/trice', 'Piastrellista', 'Elettricista per reti di distribuzione'],
    'ristorazione': ['Cuoco/a', 'Addetto/a di cucina', 'Addetto/a di ristorazione', 'Albergatore-ristoratore / Albergatrice-ristoratrice'],
    'commercio': ['Impiegato/a di commercio', 'Assistente del commercio al dettaglio', 'Impiegato/a del commercio al dettaglio'],
    'meccanica': ['Meccanico/a di manutenzione per automobili', 'Meccatronico/a d\'automobili', 'Fabbro/a di veicoli'],
    'agricoltura': ['Agricoltore/trice', 'Viticoltore/trice', 'Orticoltore/trice', 'Giardiniere/a'],
    'istruzione': ['Docente di scuola elementare', 'Docente del secondario I', 'Docente del secondario II', 'Educatore/trice dell\'infanzia']
  };
  
  return categoryMap[category.toLowerCase()] || TICINO_PROFESSIONS.slice(0, 10);
}; 